import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'adc-search',
  templateUrl: './adc-search.component.html',
  styleUrls: ['./adc-search.component.scss'],
  standalone: false
})
export class AdcSearchComponent {
  @Input() data: any;
  @Input() val!: string;
  @Input() type: string = 'basic';
  @Output() searchVal = new EventEmitter();
  @Output() searchTrigger = new EventEmitter();
  showList: boolean = false;
  suggestions: any[] = [];
  searchInput: string = '';

  constructor() { }

  search() {
    this.searchTrigger.emit(this.searchInput);
    // this.searchInput = '';
  }

  clearSearch() {
    this.searchInput = '';
    console.log(this.searchInput, 'from child')
    this.searchVal.emit(this.searchInput);
  }

  onInputChange(event: Event) {
    const inputValue = (event.target as HTMLInputElement).value;
    console.log(inputValue, 'from child')
    this.searchVal.emit(inputValue);
  }

  isInputFocused: boolean = false;

  onInputFocus() {
    this.isInputFocused = true;
  }

  onInputBlur() {
    this.isInputFocused = false;
  }
}
